<app-modal [title]="data?.title" [subtitle]="data?.subTitle">
  <section class="marTop40">
    <div *ngIf="data?.subject">
      <p>{{ data?.subject }}</p>
    </div>

    <div class="actionBtnContainer">
      <button class="actionBtn w400" (click)="cancel()" type="button">
        {{ data?.closeButtonText || 'Cancel' }}
      </button>

      <button class="actionBtn w400" (click)="confirm()" type="button">
        {{ data?.confirmButtonText }}
      </button>
    </div>
  </section>
</app-modal>
